const BreadcrumbItem = () => {
  return [
    {
      title: `Dashboard`,
      path: `/dashboard`,
      isActive: false
    },
    {
      title: `Hotel order Management`,
      path: ``,
      isActive: true
    }
  ];
};

export default BreadcrumbItem;
